export default {
  "content": "<path d=\"M8.05 8.15a.748.748 0 01-.225-.55c0-.217.075-.4.225-.55l3.425-3.425a.762.762 0 01.25-.175.734.734 0 01.537 0c.092.033.18.092.263.175L15.95 7.05c.15.15.225.333.225.55 0 .217-.075.4-.225.55a.748.748 0 01-.55.225.748.748 0 01-.55-.225L12 5.3 9.15 8.15a.748.748 0 01-.55.225.748.748 0 01-.55-.225zM12 20.7a.724.724 0 01-.525-.225L8.05 17.05a.748.748 0 01-.225-.55c0-.217.075-.4.225-.55a.748.748 0 01.55-.225c.217 0 .4.075.55.225L12 18.8l2.85-2.85a.748.748 0 01.55-.225c.217 0 .4.075.55.225.15.15.225.333.225.55 0 .217-.075.4-.225.55l-3.425 3.425a.762.762 0 01-.25.175.735.735 0 01-.275.05z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};